<template>
  <el-form :inline="formInline" :model="selectModel" label-position="right">
    <el-form-item label="名称">
      <el-input v-model="selectModel.name" placeholder="名称" />
    </el-form-item>
    <!-- <el-form-item>
      <el-button type="primary" @click="queryTableData">查询</el-button>
    </el-form-item> -->
    <el-form-item class="main-form-item-float-right">
      <el-button-group>
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="showDialogForm({created:true})">新建</el-button>
      </el-button-group>
      <el-button-group>
        <el-button type="primary" icon="el-icon-search" @click="queryTableData">查询</el-button>
      </el-button-group>
    </el-form-item>
  </el-form>

  <el-table
    :data="tableData"
    border
    stripe
    :default-sort="defaultSort"
    @sort-change="sort"
    style="width: 100%;">
    <el-table-column label="ID" prop="id" width="60px" align="center" sortable="custom" />
    <el-table-column label="创建时间" prop="createTime" min-width="180px" />
    <el-table-column label="名称" prop="name" min-width="200px" />
    <el-table-column label="描述" prop="des" min-width="200px" />
    <el-table-column
      fixed="right"
      label="操作"
      width="120">
      <template #default="scope">
        <el-button @click="showDialogForm({data: scope.row, readonly: true})" type="text" size="small">查看</el-button>
        <el-button @click="showDialogForm({data: scope.row})" type="text" size="small">编辑</el-button>
        <el-button @click="deleteAciton(scope.row)" type="text" size="small">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div style="margin-top: 10px; text-align: right;">
    <el-pagination
      layout="prev, pager, next,jumper"
      :total="total"
      @current-change="applyCurrentPage" />
  </div>

  <el-dialog custom-class="main-el-dialog" :title="dialog.title" v-model="dialog.visibled" width="600px">
    <el-form :model="dialog.form" ref="dialogForm" label-width="80px">
      <el-form-item
        label="名称" prop="name"
        :rules="[
          { required: true, message: '名称不能为空', trigger: 'blur'}
        ]">
        <el-input v-model="dialog.form.name" :readonly="dialog.readonly" />
      </el-form-item>
      <el-form-item
        label="描述" prop="des"
        :rules="[
          { required: true, message: '描述不能为空', trigger: 'blur'}
        ]">
        <el-input v-model="dialog.form.des" :readonly="dialog.readonly" />
      </el-form-item>
      <el-form-item label="权限">
        <el-tree
          :data="permissions"
          show-checkbox
          default-expand-all
          node-key="name"
          ref="tree"
          highlight-current />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialog.visibled = false">取消</el-button>
        <el-button v-if="!dialog.readonly" type="primary" @click="dialog.submit">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { handleCatchStatus } from '../../api/handler';

export default {
  data() {
    return {
      selectModel: {},
      selectSort: null,
      defaultSort: {prop: 'id', order: 'descending'},
      tableData: [],
      total: 0,
      current: 1,
      formInline: true,
      dialog: {
        visibled: false,
        created: false,
        readonly: false,
        title: '',
        form: {permissions: []},
        submit: () => true
      },
      permissions: []
    };
  },
  created() {
    this.applySortSelect(this.defaultSort);
    this.queryTableData();
    this.$api.getAllAdminPermissions().then(data => {
      data.forEach(item => this.pushPermission(item));
    });
  },
  mounted() {
  },
  methods: {
    queryTableData() {
      this.selectModel.sort = this.selectSort;
      this.selectModel.page = this.current - 1;
      this.$api.getAdminRolePage(this.selectModel)
        .then(data => {
          this.tableData = data.content;
          this.total = data.totalElements;
        });
      // .catch(handleCatchStatus)
    },
    sort({ prop, order }) {
      this.applySortSelect({ prop, order });
      this.queryTableData();
    },
    applySortSelect({ prop, order }) {
      if (order) {
        this.selectSort = `${prop},${order === 'ascending' ? 'ASC' : 'DESC'}`;
        return;
      }
      this.selectSort = null;
    },
    applyCurrentPage(current) {
      this.current = current;
      this.queryTableData();
    },
    showDialogForm({data, created = false, readonly = false}) {
      this.dialog.readonly = readonly;
      this.dialog.created = created;
      this.dialog.visibled = true;
      if (data) {
        this.dialog.form = { ...data };
        this.$api.getAdminRolePermissions(data.id).then(responseData => {
          this.dialog.form.permissions = responseData;
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(responseData);
          });
        });
      } else {
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([]);
        });
      }

      let submit;
      if (created) {
        this.dialog.title = '新建';
        this.dialog.form = {};
        submit = () => this.$api.createAdminRole(this.dialog.form);
      } else {
        this.dialog.title = '修改';
        submit = () => this.$api.updateAdminRole(this.dialog.form);
      }

      if (readonly) {
        this.dialog.title = '详情';
        submit = () => false;
      }

      this.dialog.submit = () => this.validateForm(() => Promise.resolve(this.dialog.form)
        .then(form => {
          form.permissions = this.$refs.tree.getCheckedKeys();
        })
        .then(submit)
        .then(() => {
          this.$message.success('操作成功');
          this.dialog.visibled = false;
          this.queryTableData();
        })
        .catch(handleCatchStatus));
      if (data) {
        console.log(data);
      }
    },
    validateForm(successFn) {
      this.$refs.dialogForm.validate(valid => {
        if (valid) {
          successFn();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.dialogForm.resetFields();
    },
    deleteAciton(data) {
      this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => this.$api.deleteAdminRole(data.id))
        .then(() => {
          this.$message.success('删除成功!');
          this.queryTableData();
        })
        .catch(() => this.$message.info('已取消删除'));
    },
    pushPermission(item, array = this.permissions, index = 0) {
      const keys = item.name.split(':');
      if (index + 1 === keys.length) {
        array.push({
          name: item.name,
          label: item.des
        });
        return;
      }
      index++;
      const key = keys.slice(0, index).join(':');
      for (const x of array) {
        if (x.name === key) {
          if (!x.children) {
            x.children = [];
          }
          this.pushPermission(item, x.children, index);
          return;
        }
      }
    }
  }
};
</script>
